import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "custom-multiselect__option" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentInput = _resolveComponent("ComponentInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["custom-multiselect__option-content", { 'custom-multiselect__option-content--selected': _ctx.isSelected }]),
      style: _normalizeStyle({ paddingLeft: _ctx.contentPaddingLeft }),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleSelection', _ctx.item, $event))),
      onContextmenu: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openContextMenu(_ctx.item, $event)), ["right","prevent","stop"]))
    }, [
      _createVNode(_component_ComponentInput, {
        modelValue: _ctx.isSelected,
        type: "checkbox",
        label: _ctx.item.label,
        mod: "checkbox-green"
      }, null, 8, ["modelValue", "label"]),
      (_ctx.item.hasChildren)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["custom-multiselect__toggle", { 'custom-multiselect__toggle--expanded': _ctx.isExpanded }]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggleExpanded', _ctx.item)), ["stop"]))
          }, null, 2))
        : _createCommentVNode("", true)
    ], 38)
  ]))
}